<template>
	<v-container fluid>
		<Filtro :items="headers" @filtro="filtrar"></Filtro>
		<v-data-table :group-by="$admin() ? 'matriz.nomeFantasia' : null" :server-items-length="itemsLength" :loading="loading" :items="items" :headers="headers" :footer-props="{ itemsPerPageOptions: [25] }" :options.sync="options">
			<template v-slot:[`group.header`]="{ group, toggle }">
				<td colspan="5" style="cursor:pointer" @click="toggle">{{group != 'undefined' ? group : 'Sem estabelecimento'}}</td>
			</template>
			<template v-slot:[`item.actions`]="{ item }">
				<v-btn icon @click="openEditDialog(item)" v-if="$can('usuarios:atualizar')">
					<v-icon>mdi-pencil</v-icon>
				</v-btn>
				<v-btn icon @click="openRemoveDialog(item)" v-if="$can('usuarios:remover') && item.id != $usuario().id">
					<v-icon>mdi-delete</v-icon>
				</v-btn>
				<v-btn icon @click="openAssociations(item)" v-if="$can('usuarios:listar_associacoes') && item.perfil != $enum().PERFIL_USUARIO.ADMINISTRADOR && item.id != $usuario().id">
					<v-icon>mdi-domain</v-icon>
				</v-btn>
			</template>
		</v-data-table>
		<div style="height: 80px"></div>
		<v-btn color="primary" fab dark fixed bottom right persistent @click="openAddDialog" v-if="$can('usuarios:cadastrar')">
			<v-icon>mdi-plus</v-icon>
		</v-btn>
		<v-dialog width="600" v-model="dialog" persistent scrollable>
			<v-card :loading="dialogLoading">
				<v-toolbar flat>
					<span>{{obj.id ? 'Editar' : 'Adicionar'}} Usuário</span>
					<v-spacer></v-spacer>
					<v-icon @click="dialog = false">mdi-close</v-icon>
				</v-toolbar>
				<v-divider></v-divider>
				<v-card-text>
					<Usuario v-model="obj" ref="form"></Usuario>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-btn color="secondary" @click="salvar">Salvar</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog width="300" v-model="removeDialog" persistent>
			<v-card :loading="removeLoading">
				<v-container>Deseja remover este usuário?</v-container>
				<v-divider></v-divider>
				<v-card-actions>
					<v-btn color="secondary" @click="remover">Sim</v-btn>
					<v-btn color="error" @click="removeDialog = false">Não</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog v-model="associacoesDialog" width="600" persistent>
			<v-card>
				<v-toolbar flat>
					<span>Associações de {{obj.nome}}</span>
					<v-spacer></v-spacer>
					<v-icon @click="associacoesDialog = false">mdi-close</v-icon>
				</v-toolbar>
				<v-divider></v-divider>
				<v-card-text>
					<Associacao :usuario="obj" ref="associacaoForm"></Associacao>
				</v-card-text>
			</v-card>
		</v-dialog>
	</v-container>
</template>

<script>
/* eslint-disable no-empty */
import eventBus from '../config/eventBus';
import events from '../config/events';
import Usuario from '../components/Usuario';
import Associacao from 	'../components/Associacao';

export default {
	components: {
		Usuario,
		Associacao
	},
	data(){
		return {
			items: [],
			loading: false,
			options: {},
			itemsLength: 0,
			dialog: false,
			removeDialog: false,
			dialogLoading: false,
			removeLoading: false,
			associacoesDialog: false,
			obj: {},
			where: {},
			c: 0,
			headers: [
				{ text: 'Nº', value: 'id', sortable: false },
				{ text: 'Nome', value: 'nome', sortable: false, filtro: 'text' },
				{ text: 'Email', value: 'email', sortable: false, filtro: 'text' },
				{ text: 'Perfil', value: 'perfil', sortable: false, filtro: 'select', options: Object.values(this.$enum().PERFIL_USUARIO) },
				{ text: '', value: 'actions', sortable: false, align: 'right', width: 148 }
			]
		};
	},
	created(){
		eventBus.$on(events.REFRESH, this.carregar);
		eventBus.$on(events.ESTABELECIMENTOS_ATUALIZADOS, this.carregar);
	},
	destroyed(){
		eventBus.$off(events.REFRESH, this.carregar);
		eventBus.$off(events.ESTABELECIMENTOS_ATUALIZADOS, this.carregar);
	},
	methods: {
		filtrar(values){
			this.where = {
				...(values.nome ? { iLike_nome: `%${values.nome}%` } : {}),
				...(values.email ? { iLike_email: `%${values.email}%` } : {}),
				...(values.perfil ? { perfil: values.perfil } : {})
			};
			this.carregar(1);
		},
		async carregar(page) {
			this.loading = true;
			try {
				const result = await this.$usuariosService.find(page, {
					in_matrizId: this.$admin() ? (this.$estabelecimentos().map(x => x.id).join(',') || null) : null,
					...this.where
				});
				this.items = result.docs;
				this.options.page = result.page;
				this.itemsLength = result.total;
			}
			catch(err){
				console.log(err);
			}
			this.loading = false;
		},
		async salvar(){
			if(this.$refs.form.validate()) {
				this.dialogLoading = true;
				try {
					if(this.obj.id) {
						await this.$usuariosService.update(this.obj.id, this.obj);
						this.carregar(this.options.page);
					}
					else {
						await this.$usuariosService.create(this.obj);
						this.carregar(1);
					}
				}
				catch(err){
					console.log(err);
				}
				this.dialog = false;
				this.dialogLoading = false;
			}
		},
		async remover(){
			this.removeLoading = true;
			try {
				await this.$usuariosService.remove(this.obj.id);
				this.carregar(this.items.length == 1 ? this.options.page - 1 : this.options.page);
			}
			catch(e) {}
			this.removeDialog = false;
			this.removeLoading = false;
		},
		openEditDialog(obj){
			this.resetForm();
			this.$nextTick(() => {
				obj.c = ++this.c;
				this.obj = JSON.parse(JSON.stringify(obj));
				this.dialog = true;
			});
		},
		openAddDialog(){
			this.resetForm();
			this.$nextTick(() => {
				this.obj = {
					c: ++this.c,
					ativo: true
				};
				this.dialog = true;
			});
		},
		openAssociations(obj){
			this.resetAssociacoes();
			this.$nextTick(() => {
				obj.c = ++this.c;
				this.obj = JSON.parse(JSON.stringify(obj));
				this.associacoesDialog = true;
			});
		},
		openRemoveDialog(obj){
			this.obj = JSON.parse(JSON.stringify(obj));
			this.removeDialog = true;
		},
		resetForm(){
			if(this.$refs.form){
				this.$refs.form.reset();
			}
		},
		resetAssociacoes(){
			if(this.$refs.associacaoForm){
				this.$refs.associacaoForm.reset();
			}
		}
	},
	watch: {
		options(v) {
			this.carregar(v.page);
		}
	}
};
</script>